module.exports = __webpack_public_path__ + "static/media/typeE.a11468ff.jpg";